export default "<p>pedido-list works!</p>\n"